import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type AutoPopulateAccommodationPlacesV5MutationVariables = Types.Exact<{
  payload: Types.AutoPopulateAccommodationPlacesPayloadV5;
}>;

export type AutoPopulateAccommodationPlacesV5Mutation = {
  __typename?: 'Mutation';
  autoPopulateAccommodationPlacesV5: {
    __typename?: 'AutoPopulateResponseV5';
    error?: string | null;
    idempotentId: string;
    status: Types.AutopopulateJobStatusV5;
    result?: Array<{
      __typename?: 'AutoPopulateResultItemV4';
      accommodationPlaceId: string;
      proposedNoteFromHostToGuest?: string | null;
      whyThisHotelIsAGreatPick?: string | null;
    }> | null;
  };
};

export type AutopopulateOperationFragment = {
  __typename?: 'AutopopulateOperationItemV20251203';
  error?: string | null;
  eventId: string;
  idempotentId: string;
  status: Types.AutopopulateJobStatusV5;
  result?: {
    __typename?: 'AutoPopulateResultV20251203';
    algoTag?: string | null;
    items: Array<{ __typename?: 'AutoPopulateResultItemV4'; accommodationPlaceId: string; proposedNoteFromHostToGuest?: string | null; whyThisHotelIsAGreatPick?: string | null }>;
  } | null;
};

export type AutopopulateOperationsByEventIdQueryVariables = Types.Exact<{
  payload: Types.AutopopulateOperationsByEventIdPayload;
}>;

export type AutopopulateOperationsByEventIdQuery = {
  __typename?: 'Query';
  autopopulateOperationsByEventIdV20251203: {
    __typename?: 'AutopopulateOperationsByEventIdResponseV20251203';
    operations: Array<{
      __typename?: 'AutopopulateOperationItemV20251203';
      error?: string | null;
      eventId: string;
      idempotentId: string;
      status: Types.AutopopulateJobStatusV5;
      result?: {
        __typename?: 'AutoPopulateResultV20251203';
        algoTag?: string | null;
        items: Array<{
          __typename?: 'AutoPopulateResultItemV4';
          accommodationPlaceId: string;
          proposedNoteFromHostToGuest?: string | null;
          whyThisHotelIsAGreatPick?: string | null;
        }>;
      } | null;
    }>;
  };
};

export const AutopopulateOperationFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutopopulateOperation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutopopulateOperationItemV20251203' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idempotentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'algoTag' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accommodationPlaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'whyThisHotelIsAGreatPick' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const AutoPopulateAccommodationPlacesV5Document = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AutoPopulateAccommodationPlacesV5' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AutoPopulateAccommodationPlacesPayloadV5' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autoPopulateAccommodationPlacesV5' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idempotentId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'result' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accommodationPlaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'whyThisHotelIsAGreatPick' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type AutoPopulateAccommodationPlacesV5MutationFn = Apollo.MutationFunction<AutoPopulateAccommodationPlacesV5Mutation, AutoPopulateAccommodationPlacesV5MutationVariables>;

/**
 * __useAutoPopulateAccommodationPlacesV5Mutation__
 *
 * To run a mutation, you first call `useAutoPopulateAccommodationPlacesV5Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAutoPopulateAccommodationPlacesV5Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [autoPopulateAccommodationPlacesV5Mutation, { data, loading, error }] = useAutoPopulateAccommodationPlacesV5Mutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAutoPopulateAccommodationPlacesV5Mutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<AutoPopulateAccommodationPlacesV5Mutation, AutoPopulateAccommodationPlacesV5MutationVariables>,
) {
  return ApolloReactHooks.useMutation<AutoPopulateAccommodationPlacesV5Mutation, AutoPopulateAccommodationPlacesV5MutationVariables>(
    AutoPopulateAccommodationPlacesV5Document,
    baseOptions,
  );
}
export type AutoPopulateAccommodationPlacesV5MutationHookResult = ReturnType<typeof useAutoPopulateAccommodationPlacesV5Mutation>;
export type AutoPopulateAccommodationPlacesV5MutationResult = Apollo.MutationResult<AutoPopulateAccommodationPlacesV5Mutation>;
export type AutoPopulateAccommodationPlacesV5MutationOptions = Apollo.BaseMutationOptions<
  AutoPopulateAccommodationPlacesV5Mutation,
  AutoPopulateAccommodationPlacesV5MutationVariables
>;
export const AutopopulateOperationsByEventIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AutopopulateOperationsByEventId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AutopopulateOperationsByEventIdPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'autopopulateOperationsByEventIdV20251203' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'operations' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AutopopulateOperation' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AutopopulateOperation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'AutopopulateOperationItemV20251203' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'error' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idempotentId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'result' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'algoTag' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accommodationPlaceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'proposedNoteFromHostToGuest' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'whyThisHotelIsAGreatPick' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useAutopopulateOperationsByEventIdQuery__
 *
 * To run a query within a React component, call `useAutopopulateOperationsByEventIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutopopulateOperationsByEventIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutopopulateOperationsByEventIdQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useAutopopulateOperationsByEventIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>,
) {
  return ApolloReactHooks.useQuery<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>(AutopopulateOperationsByEventIdDocument, baseOptions);
}
export function useAutopopulateOperationsByEventIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>(AutopopulateOperationsByEventIdDocument, baseOptions);
}
export type AutopopulateOperationsByEventIdQueryHookResult = ReturnType<typeof useAutopopulateOperationsByEventIdQuery>;
export type AutopopulateOperationsByEventIdLazyQueryHookResult = ReturnType<typeof useAutopopulateOperationsByEventIdLazyQuery>;
export type AutopopulateOperationsByEventIdQueryResult = Apollo.QueryResult<AutopopulateOperationsByEventIdQuery, AutopopulateOperationsByEventIdQueryVariables>;
